module.exports = __webpack_public_path__ + "images/application/illustrations/speed-425225d9.svg";